const PriceCurrencies = [
  { id: 'AUD', name: 'AUD (Australian Dollar)' },
  { id: 'CAD', name: 'CAD (Canadian Dollar)' },
  { id: 'EUR', name: 'EUR (Euro)' },
  { id: 'GBP', name: 'GBP (British Pound)' },
  { id: 'USD', name: 'USD (US Dollar)' }
];

export default PriceCurrencies;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Pmp/StaticData/PriceCurrencies.tsx